import * as React from "react";
import { IStudyQualification } from "../../../model";
import { MddDialog, MddDialogButtons } from "../../common";
import { SagaService } from "front-end-lib/core";
import { eStudySaga } from "../../../sagas";
import { isLoading } from "../../../utils";

interface IMddStudyQualificationDeleteDialogProps {
  qual: IStudyQualification;
  open: boolean;
  onClose: () => void;
}

export const MddStudyQualificationDeleteDialog = ({
  qual,
  open,
  onClose
}: IMddStudyQualificationDeleteDialogProps) => {
  const deleteInProgress = isLoading(
    `undefined_${eStudySaga.DELETE_STUDY_QUALIFICATION}`
  );

  const handleDeleteQualification = React.useCallback(() => {
    SagaService.dispatchSaga({
      type: eStudySaga.DELETE_STUDY_QUALIFICATION,
      payload: qual
    });
  }, [qual]);

  const dialogActions = React.useMemo(
    () => (
      <MddDialogButtons
        saveButtonProps={{
          disabled: deleteInProgress,
          onClick: handleDeleteQualification
        }}
        saveButtonText="Delete"
        closeButtonProps={{
          onClick: onClose
        }}
      />
    ),
    [deleteInProgress, handleDeleteQualification, onClose]
  );

  return (
    <MddDialog
      showCloseButton
      onCloseClick={onClose}
      submitting={deleteInProgress}
      dialogProps={{
        id: "divDeleteQualDialog",
        open
      }}
      dialogActionProps={{ id: "divDeleteQualDialogActions" }}
      dialogContentProps={{
        id: "divDeleteQualDialogContent"
      }}
      dialogTitleProps={{
        id: "divDeleteQualDialogTitle",
        title: "Delete Study Qualification"
      }}
      dialogContent={
        <div id="divTitle" className="displayRelative">
          <p id="deleteConfirmationMessage">
            {`Are you sure you want to delete qualification '${qual.QualificationName}' from this study? All associated data will be deleted.`}
          </p>
        </div>
      }
      dialogActions={dialogActions}
    />
  );
};
